import * as React from "react";
import { HeadFC, navigate, PageProps } from "gatsby";
import MainLayout from "../layouts/main-layout";
import Button from "../components/button/Button";
import RightArrow from "../icons/right-arrow";
import HeroImage from "../../static/assets/hero-image.png";
import KeepContactImage from "../../static/assets/keep-contact-image.png";
import CooperationSlider from "../modules/cooperation-slider/CooperationSlider";
import BubbleChatIcon from "../icons/bubble-chat-icon";
import ListIcon from "../icons/list-icon";
import PenToolIcon from "../icons/pen-tool-icon";
import ReviewIcon from "../icons/review-icon";
import Card from "../components/card/Card";
import MortarboardIcon from "../icons/mortarboard-icon";
import HandshakeIcon from "../icons/handshake-icon";
import SearchIcon from "../icons/search-icon";
import AchievementIcon from "../icons/achievement-icon";
import LettersBackgroundImage from "../../static/assets/letters-background-1-image.png";
import Reviews from "../modules/customers-opinion/Reviews";
import ReviewsImage from "../../static/assets/reviews-image.png";
import TextCorrection from "../components/text-correction/text-correction";

const IndexPage: React.FC<PageProps> = () => {
  return (
    <MainLayout>
      <section className="my-4 px-4 grid grid-cols-1 gap-12 laptop:grid-cols-[35%_65%] items-center">
        <div className="tablet:w-2/3 laptop:w-full">
          <h1 className="text-brand">Mam na imię Kinga.</h1>
          <h1 className="pr-[25px] tablet:pr-0">
            Poprawmy razem{" "}
            <TextCorrection
              correctedText="Twój"
              correctedTextPosition="bottomRight"
            >
              twuj
            </TextCorrection>{" "}
            tekst!
          </h1>
          <p className="my-10">
            Jestem korektorem z wykształcenia i powołania. Skorzystaj z
            profesjonalnych usług korektora tekstów.
          </p>
          <div className="flex flex-col tablet:flex-row gap-4 items-start">
            <Button
              color="blue"
              trailingIcon={<RightArrow />}
              onClick={() => navigate("/contact")}
            >
              Napisz do mnie
            </Button>
            <Button
              trailingIcon={
                <strong>
                  <RightArrow />
                </strong>
              }
              onClick={() => navigate("/portfolio")}
            >
              Moje portfolio
            </Button>
          </div>
        </div>
        <div>
          <img src={HeroImage} alt="Zdjęcie tła" />
        </div>
      </section>

      <CooperationSlider />

      <section className="px-4 tablet:px-12 laptop:px-0 flex flex-col laptop:flex-row items-center">
        <img src={KeepContactImage} alt="Zdjęćie tła" />
        <div className="flex flex-col items-start gap-10">
          <h1>
            Stały kontakt i pełna{" "}
            <TextCorrection
              correctedText="satysfakcja"
              correctedTextPosition="bottomRight"
            >
              styfakcja
            </TextCorrection>
          </h1>
          <p>
            Pozostaję w stałym kontakcie ze zleceniodawcą. Pracujemy razem do
            uzyskania efektu satysfakcjonującego obie strony.
          </p>
          <div className="flex flex-col gap-4">
            <div className="flex gap-4 items-center">
              <BubbleChatIcon />
              <b>
                <p>Stały kontakt z klientem</p>
              </b>
            </div>
            <div className="flex gap-4 items-center">
              <ListIcon />
              <b>
                <p>Indywidualna wycena dla prywatnych klientów</p>
              </b>
            </div>
            <div className="flex gap-4 items-center">
              <PenToolIcon />
              <b>
                <p>Szanuję indywidualny styl autora i nie ingeruję w niego</p>
              </b>
            </div>
            <div className="flex gap-4 items-center">
              <ReviewIcon />
              <b>
                <p>Pracujemy do uzyskania najlepszego efektu </p>
              </b>
            </div>
          </div>
          <Button
            trailingIcon={
              <strong>
                <RightArrow />
              </strong>
            }
            onClick={() => navigate("/prices")}
          >
            Sprawdź mój cennik
          </Button>
        </div>
      </section>

      <section className="relative">
        <img
          src={LettersBackgroundImage}
          alt="Zdjęcie tła"
          className="hidden tablet:block absolute z-10 bottom-0 laptop:top-1/2 left-1/2 transform laptop:-translate-x-1/2 -translate-y-1/2"
        />
        <div className="relative z-20 mt-20 px-4 tablet:px-12 laptop:px-0 flex flex-col laptop:flex-row laptop:items-center laptop:justify-between">
          <div className="flex flex-col items-start gap-8 max-w-[473px]">
            <h1>
              <TextCorrection
                correctedText="Profesjonalna"
                correctedTextPosition="topRight"
              >
                Fajna i dobra
              </TextCorrection>{" "}
              korekta tekstów
            </h1>
            <p>
              Wykształcenie kierunkowe i kilkuletnie doświadczenie pozwala mi na
              wykonywanie profesjonalnej redakcji oraz korekty tekstów różnego
              rodzaju. Niestraszne mi artykuły prasowe, praca dyplomowa,
              beletrystyka, monografia naukowa czy nawet poezja.
            </p>
            <Button
              trailingIcon={
                <strong>
                  <RightArrow />
                </strong>
              }
              onClick={() => navigate("/contact")}
            >
              Zacznij współpracę
            </Button>
          </div>
          <div className="grid grid-cols-1 gap-4 tablet:grid-cols-2 tablet:gap-10 mt-10">
            <Card
              headerIcon={<MortarboardIcon />}
              title="Kierunkowe wykształcenie"
              description="Wykształcenie kierunkowe i kilkuletnie doświadczenie pozwala mi na wykonywanie profesjonalnej redakcji oraz korekty tekstów różnego rodzaju."
            />
            <Card
              headerIcon={<AchievementIcon />}
              title="Podejmuję wyzwania"
              description="Niestraszne mi artykuły prasowe, praca dyplomowa, beletrystyka, monografia naukowa czy nawet poezja."
            />
            <Card
              headerIcon={<HandshakeIcon />}
              title="Elastyczna współpraca"
              description="Współpracuję zarówno z wydawnictwami, jak i osobami prywatnymi."
            />
            <Card
              headerIcon={<SearchIcon />}
              title="Jasne zasady współpracy "
              description="Nie wykonuję redakcji merytorycznej. Nie piszę tekstów za autorów. Nie dopisuję brakujących fragmentów, nie uzupełniam źródeł ani bibliografii. Nie przeprowadzam redakcji pod kątem antyplagiatowym."
            />
          </div>
        </div>
      </section>

      <section className="bg-gray-4 px-4 tablet:px-12 tablet:mx-4 laptop:px-0 laptop:mx-0 flex flex-col laptop:flex-row items-center mt-20">
        <img
          className="w-auto -mt-16 tablet:-mt-16"
          src={ReviewsImage}
          alt="Zdjęcie tła"
        />
        <div className="w-auto my-10 laptop:px-[113px]">
          <h1>
            Co{" "}
            <TextCorrection
              correctedText="klienci"
              correctedTextPosition="topLeft"
            >
              oni
            </TextCorrection>
          </h1>
          <h1>mówią o mnie?</h1>
          <Reviews />
        </div>
      </section>
    </MainLayout>
  );
};

export default IndexPage;

export const Head: HeadFC = () => (
  <title>Kinga Dolczewska - Redakcja i korekta tekstów</title>
);
